export const WHEELS_SERVICE_ENDPOINTS = {
  getPriceConfig: `${process.env.GATSBY_BASE_API}/wheels/pricing/config`,
} as const;
